import { render, staticRenderFns } from "./ViewAsRoleChip.vue?vue&type=template&id=8b609af8&scoped=true"
import script from "./ViewAsRoleChip.vue?vue&type=script&lang=js"
export * from "./ViewAsRoleChip.vue?vue&type=script&lang=js"
import style0 from "./ViewAsRoleChip.vue?vue&type=style&index=0&id=8b609af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b609af8",
  null
  
)

export default component.exports